import $ from 'cash-dom';
import DeviceSizes from '../../components/DeviceSizes';

class ContentSection {
	constructor(contentSectionsSelector, showOnMobile = false) {
		this._$vendorsList = $('.vendors-list');
		this._contentSectionsSelector = contentSectionsSelector;
		this._$contentSections = $(this._contentSectionsSelector);
		this._isMobile = window.innerWidth < DeviceSizes.MD;
		this._showOnMobile = showOnMobile;
	}

	init() {
		this._showNeededTipSection();

		$(document).on('filters-change', () => {
			this._showNeededTipSection();
		});
	}

	_showNeededTipSection() {
		this._$contentSections.hide();
		$('.content-section-clone').remove();

		// don't show content section for mobile
		if (!this._showOnMobile && this._isMobile) {
			return;
		}

		const $visibleVendors = this._$vendorsList.find('.ppc-single-vendor').not('.hidden');
		const visibleVendorsLength = $visibleVendors.length;

		let index = null;

		if (visibleVendorsLength >= 3) {
			index = 2;
		} else if (visibleVendorsLength) {
			index = visibleVendorsLength - 1;
		}

		const $visibleVendor = $($visibleVendors.get(index));

		if ($visibleVendor.length) {
			const $firstVisibleVendor = $($visibleVendors.get(0));
			const $firstContentSection = $firstVisibleVendor.next(this._contentSectionsSelector).clone();

			if ($firstContentSection.length) {
				$firstContentSection.addClass('content-section-clone').css('display', 'flex');

				if (Alooma) {
					Alooma.applyAloomaTrackingForLink($firstContentSection.get(0));

					$firstContentSection.find('a').each(function (i, e) {
						Alooma.applyAloomaTrackingForLink(e);
					});
				}

				$visibleVendor.after($firstContentSection);
			}
		}
	}
}

export default ContentSection;
